import { mapMutations, mapGetters } from "vuex";
import CatalogList from "@/components/catalog-list/index.vue";

export default {
    name: "header-catalog",
    data() {
        return {};
    },
    components: {
        CatalogList,
    },
    computed: {
        ...mapGetters({
            showCatalogMenu: "system/showCatalogMenu",
            config: "setting/menu",
        }),
    },
    created() {
        document.addEventListener("keyup", this.myMethod);
        this.$root.$refs.A = this;
    },
    methods: {
        ...mapMutations({
            changeShowCatalogMenu: `system/CHANGE_SHOW_CATALOG_MENU`,
            fixBody: `system/FIX_BODY`,
        }),
        myMethod(event) {
            if (event.keyCode === 27) {
                this.changeShowCatalogMenu(false);
            }
        },

        changeShowCatalog() {
            if (this.showCatalogMenu) {
                this.changeShowCatalogMenu(false);
            } else {
                this.changeShowCatalogMenu(true);
                // this.fixBody(true)
            }
        },
    },
};
